import { Team } from '@ori/testid-generator';
export var APPLICATION_NAME = 'sharing-panel';
export var TEAM = Team.Checkout;
export var vendorDataAttribute = 'data-vendor';